export default {
	functional: true,
	props: {
		num: {
			type: Number,
			require: true,
		},
	},
	name: 'NumRed',
	render(h, context) {
		return h(
			'span',
			{
				class: 'global-num-red',
			},
			context.props.num
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/NumRed.js